type EventHandler = (success: boolean, message: string) => void;

export enum EmitEvent {
  Result = "RESULT",
  ComponentDropped = "COMPONENT_DROPPED",
  LayoutChanged = "LAYOUT_CHANGED"
}

export class ActionEmitter {
  private events: Map<string, EventHandler[]> = new Map();

  // Subscribe to an event
  on(event: string, listener: EventHandler): void {
    if (!this.events.has(event)) {
      this.events.set(event, []);
    }
    this.events.get(event)?.push(listener);
  };

  // Emit an event with both a boolean and a string
  emit(event: string, success: boolean, message: string): void {
    if (this.events.has(event)) {
      this.events.get(event)?.forEach(listener => listener(success, message));
    }
  };

  // Unsubscribe from an event
  off(event: string, listener: EventHandler): void {
    const listeners = this.events.get(event);
    if (listeners) {
      this.events.set(event, listeners.filter(l => l !== listener));
    }
  };
}

export const actionEmitter = new ActionEmitter();